import React from "react";
import { useLocation } from "react-router-dom";
import "./App.css";
import Header from "./Components/Header";
import Menu from "./Components/Menu";
import cateringPDF from "./images/CateringMenu25.pdf";

const GOOGLE_MAPS_PLACES_KEY = "AIzaSyDlyYLD-GThLSHUwuNYT0ttLQQ_CG2TQmA";
const CUT_LUNCH_PLACE_ID = "ChIJzQwiA56zEmsRFuUi8FFFkzk";
const FALLBACK_HOURS = [
  "MON - FRI 6AM - 2:30PM",
  "SAT 6:30AM - 3:00PM",
  "SUN 7AM - 3:00 PM"
];

function loadGoogleMapsPlaces() {
  if (window.google && window.google.maps && window.google.maps.places) {
    return Promise.resolve();
  }

  const existingScript = document.querySelector("script[data-google-places='true']");
  if (existingScript) {
    return new Promise((resolve, reject) => {
      existingScript.addEventListener("load", () => resolve());
      existingScript.addEventListener("error", () => reject(new Error("Failed to load Google Places")));
    });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_PLACES_KEY}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.dataset.googlePlaces = "true";
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load Google Places"));
    document.head.appendChild(script);
  });
}

function SiteFooter() {
  const [openingHours, setOpeningHours] = React.useState(FALLBACK_HOURS);

  React.useEffect(() => {
    let mounted = true;

    loadGoogleMapsPlaces()
      .then(() => {
        if (!window.google || !window.google.maps || !window.google.maps.places) {
          return;
        }

        const request = {
          placeId: CUT_LUNCH_PLACE_ID,
          fields: ["opening_hours"]
        };

        const service = new window.google.maps.places.PlacesService(document.createElement("div"));
        service.getDetails(request, (place, status) => {
          if (!mounted) {
            return;
          }

          if (
            status === window.google.maps.places.PlacesServiceStatus.OK &&
            place?.opening_hours?.weekday_text?.length
          ) {
            setOpeningHours(place.opening_hours.weekday_text);
          }
        });
      })
      .catch(() => {
        if (mounted) {
          setOpeningHours(FALLBACK_HOURS);
        }
      });

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <footer className="site-footer" id="contact">
      <div className="site-footer-col">
        <p className="site-footer-title">CONTACT</p>
        <p>220 Clovelly Road, Randwick 2031</p>
        <p>For catering enquiries: kitchen@cutlunchdeli.com.au</p>
        <p>For any and everything else: sunday@cutlunchdeli.com.au</p>
        <a
          className="site-instagram-link"
          href="https://www.instagram.com/cutlunchdeli/"
          target="_blank"
          rel="noreferrer"
          aria-label="Cut Lunch Deli on Instagram"
        >
          <span className="site-instagram-icon">◎</span>
        </a>
      </div>

      <div className="site-footer-col site-footer-hours">
        <p className="site-footer-title">HOURS</p>
        {openingHours.map((hoursLine) => (
          <p key={hoursLine}>{hoursLine}</p>
        ))}
      </div>
    </footer>
  );
}

function App() {
  const location = useLocation();
  const [cateringMenuUrl, setCateringMenuUrl] = React.useState("");
  const isMenuPage = location.pathname === "/menu";

  React.useEffect(() => {
    let mounted = true;

    fetch("./resumeData.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Could not load site configuration");
        }
        return response.json();
      })
      .then((resumeData) => {
        if (mounted) {
          setCateringMenuUrl(resumeData?.main?.cateringMenuPdfUrl || "");
        }
      })
      .catch(() => {
        if (mounted) {
          setCateringMenuUrl("");
        }
      });

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <main className="site-shell">
      <Header
        cateringMenuUrl={cateringMenuUrl || cateringPDF}
        showHero={!isMenuPage}
      />
      {isMenuPage ? <Menu /> : null}
      <SiteFooter />
    </main>
  );
}

export default App;
